import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  background-color: #fff;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;

  .form-control {
    width: 1050% !important;
    height: 50px;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid ${({ error }) => (error ? "red" : "#b2b2b2")};
  }

  .form-control {
    font-size: 14px;
    color: #272727;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  margin: 0 auto 0;
  max-width: 1000px;

  @media (max-width: 992px){
    max-width: 970px;
    margin: 0 auto 0;
    flex-direction: column-reverse;
  }

  @media (max-width: 768px) {
    max-width: 750px;
    margin: 0 auto 0;
    flex-direction: column-reverse;
  }

  @media (max-width: 576px){
    max-width: 540px;
    margin: 0 auto 0;
    flex-direction: column-reverse;
  }
`;

export const WrapperButtonBack = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  margin: 30px auto 0;
  max-width: 965px;
  width: 95%;

  @media (max-width: 992px){
    max-width: 95%;
    margin: 20px auto 0;
    flex-direction: row;
  }

`;

export const FormContainer = styled.div`
  width: 590px;

  div {
    display: flex;
    flex-direction: row;
  }

  @media(max-width: 992px) {
    width: 100%;
  }
`;

export const FormContainerAuth = styled.div`

  div {
    display: flex;
    flex-direction: row;
  }

  @media(max-width: 992px) {
    width: 100%;
  }
`;

export const WrapperTitle = styled.div`
  width: 570px;
  display: flex;
  align-items: center;
  z-index: 2;

  margin-top: -10px;
  margin-bottom: ${({ hidden }) => (hidden === "false" ? 0 : 10)}px;

  @media(max-width: 992px) {
    width: 100%;
  }
`;

export const Circle = styled.div`
  width: 50px;
  height: 50px;
  margin: 10px 17px;
  border-radius: 50%;
  background-color: #3CACFC ;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: #fff;
    font-size: 17px;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
  }
`;

export const Title = styled.h3`
  color: #222;
  font-size: 25px;
  font-weight: 700;
  line-height: 30px;
  font-family: 'Montserrat', sans-serif;

  margin-right: 17px;
`;

export const Line = styled.div`
  height: auto;
  z-index: 1;
  width: 3px !important;
  background-color: #3CACFC;
  margin: -50px 0px -20px 40px;

  @media(max-width: 720px) {
    background-color: transparent;
  }
`;

export const FormContent = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 60px 20px 42px;

  @media(max-width: 720px) {
    margin: 0 60px 20px 0;
  }

  .inputAutoCompleteEmail {
    opacity: 0;
    height: 0px;
    border: none;
  }
`;

export const FormContentAuth = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;

  .inputAutoCompleteEmail {
    opacity: 0;
    height: 0px;
    border: none;
  }
`;

export const FormContentRow = styled.form`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin: 20px 0;

  .inputAutoCompleteEmail {
    opacity: 0;
    height: 0px;
    border: none;
  }
`;

export const WrapperInvalidPassword = styled.div`
  display: flex;
  flex-direction: column !important;
  margin-bottom: 15px;

  div {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 5px;

    p {
      font-size: 14px;
    }
  }
`;

export const ButtonNext = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;

  border: none;
  cursor: pointer;
  margin-top: 30px;
  border-radius: 30px;
  background-color: #3cacfc;

  color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 15px 33px;
  text-transform: uppercase;

  &:hover {
    filter: brightness(.9);
    transition: .2s;
  }
`;

export const Buttonback = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;

  border: none;
  cursor: pointer;
  margin-bottom: 30px;
  border-radius: 30px;
  background-color: #3cacfc;

  color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 15px 33px;
  text-transform: uppercase;

  ${({ back }) =>
    back === "true" &&
    css`
      padding: 8px 25px;
      font-size: 13px;
  `}

  &:hover {
    filter: brightness(.9);
    transition: .2s;
  }
`;

export const CardReviewSubscription = styled.div`
  gap: 15px;
  display: flex;
  flex-direction: row !important;
  justify-content: space-between;

  border-radius: 12px;
  background-color: #3DA8FE;
  padding: 20px;
  color: #fff;

  @media(max-width: 992px) {
    flex-direction: column !important;;
  }
`;

export const DivLeft = styled.div`
  display: flex;
  flex-direction: column !important;

  div {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;

    sub {
      color: #FFF;
      font-size: 13px;
      font-weight: 700;
      text-transform: lowercase;
      font-family: 'Montserrat', sans-serif;
      margin-bottom: 3px;

      &:first-child {
        margin-right: 5px;
        text-transform: capitalize;
      }
    }

    span {
      color: #FFF;
      font-size: 23px;
      font-weight: 700;
      font-family: 'Montserrat', sans-serif;
    }
  }
`;

export const Discount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  color: #fff;
  font-size: 13px;
  font-weight: 500;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: rgb(11, 161, 6);
`;

export const DivRight = styled.div`
  gap: 12px;
  display: flex;
  align-items: flex-start;
  flex-direction: column !important;

  div {
    gap: 5px;
    display: flex;
    align-items: center;

    input {
      width: 20px;
      height: 20px;
    }

    label {
      color: #FFF;
      font-size: 13px;

      @media(max-width: 720px) {
        font-size: 12px;
      }
    }
  }

  p {
    color: #FFF;
    font-size: 14px;
    line-height: 18px;
    text-align: justify;

    span {
      font-weight: 700;
    }

    @media(max-width: 720px) {
      font-size: 13px;
      line-height: 16px;
    }
  }
`;

export const TextPrivacyTerms = styled.div`
  gap: 7px;
  display: flex;
  flex-direction: column !important;
  margin-top: 15px;
  padding: 0 18px;

  p {
    color: #222222;
    font-size: 15px;
    font-weight: 500;
    line-height: 18px;

    @media(max-width: 720px) {
      font-size: 13px;
    }

    a {
      color: #3DA8FE;
      font-weight: 700;
      padding-left: 5px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const WrapperBuy = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  margin-bottom: 30px;

  img {
    height: 27px;
  }
`;

export const BtImageCheckout = styled.div`
  display: flex;
  flex-direction: row !important;
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-grow: 1;

  margin: 10px 0;
  border-radius: 21px;
  min-width: 270px !important;
  padding: 20px 40px;
  background-color: ${({ active }) => (active ? "rgba(61, 168, 254, 1)" : "#fff")};
  color: ${({ active }) => (active ? "#fff" : "unset")};
  box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.27);

  cursor: pointer;

  img{
    max-width: 100px;
  }

  .column{
    display: flex;
    flex-direction: column !important;
    justify-content: center;
    align-items: center;
    gap: 5px;

    width: 60%;
  }

  :hover{
    background-color: rgba(61, 168, 254, 1);
    color: #fff;
    p{
      color: #fff;
      font-family: "Inter", sans-serif;
      font-weight: 500;
      text-transform: capitalize;
      font-size: 23px;
      line-height: 27px;
      text-align: center;

      strong{
        font-weight: 700;
      }
    }
  }

  p{
    color: ${({ active }) => (active ? "#fff" : "rgba(11, 152, 246, 1)")};
    font-family: "Inter", sans-serif;
    font-weight: 500;
    text-transform: capitalize;
    font-size: 23px;
    line-height: 27px;
    text-align: center;

    strong{
      font-weight: 700;
    }
  }

  span{
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
  }


`;
